import { render, staticRenderFns } from "./RessourcesCarousel.vue?vue&type=template&id=bc5f5c78"
import script from "./RessourcesCarousel.vue?vue&type=script&lang=js"
export * from "./RessourcesCarousel.vue?vue&type=script&lang=js"
import style0 from "./RessourcesCarousel.vue?vue&type=style&index=0&id=bc5f5c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports